"use client";

import { LomdaProviderProps } from "../lib/types";
import {
    EditorStoreProvider,
    RenderAudioSync,
    StoreAutoSave,
} from "../store";

export const LomdaProvider = ({
    userId,
    lomdaId,
    lomdaName,
    content,
    metadata,
    initialAssets,
    readOnly = false,
    mode = "edit",
    initialSelectedSceneId,
    children,
}: LomdaProviderProps) => {
    const init = {
        userId,
        lomdaId,
        lomdaName,
        content,
        metadata,
        assets: initialAssets ?? [],
        mode,
        readOnly,
        initialSelectedSceneId,
    };
    return (
        <EditorStoreProvider init={init}>
            {!readOnly && <StoreAutoSave />}
            {!readOnly && <RenderAudioSync />}
            {children}
        </EditorStoreProvider>
    );
};
